import React from 'react';

const isLoading = state => {
  return state.videos.loading.videos;
};

const getVideosData = state => {
  if (!state.videos.videos) {
    return [];
  }

  return state.videos.videos;
};

export const VideosSelector = {
  isLoading,
  getVideosData,
};
